import clsx from 'clsx';
import { useState } from 'react';

import { TaskBuying } from '@/api/spirit';
import { ReactComponent as DownArrowIcon } from '@/assets/icons/bx-chevron-down.svg';
import SpiritDetailBuyingIcon from '@/assets/icons/spirit_detail_buying_icon.png';
import { addCommaAmount } from '@/utils/format';

export const Buying = (props: { task: TaskBuying }) => {
  const [isToggle, setToggle] = useState<boolean>(false);
  const { task } = props;
  const isEC = 'ecUrl' in task;

  return (
    <div className="flex justify-center gap-3">
      <div className="flex flex-col items-center text-sm">
        <div className="flex aspect-square w-10 items-center justify-center rounded-full bg-white">
          <img src={SpiritDetailBuyingIcon} alt="" />
        </div>
        <div className={clsx('w-[2px] bg-gray-300', isToggle ? 'h-full' : 'h-[50px]')} />
      </div>
      <div className="w-[190px]">
        <h5 className="mb-2 font-semibold leading-5 ">{isEC ? 'バイイング（EC）' : 'バイイング（店舗）'}</h5>
        <p className="mb-2 text-sm font-semibold text-gray-400">{task.title}</p>
        {isToggle && (
          <div className="mb-2 w-[190px] rounded-lg bg-gray-100">
            <div className="mb-2 gap-2">
              <p className="text-sm font-semibold">購入期間</p>
              <p className="text-xs">
                {task.startedAt} ~ {task.endedAt}
              </p>
            </div>
            {!isEC && (
              <div className="mb-2 gap-2">
                <p className="text-sm font-semibold">店舗情報</p>
                <p className="text-xs">{task.shopInformation}</p>
              </div>
            )}
            {isEC && (
              <>
                <div className="mb-2 gap-2">
                  <p className="text-sm font-semibold">購入先URL</p>
                  <p className="text-xs">{task.ecUrl}</p>
                </div>
                <div className="mb-2 gap-2">
                  <p className="text-sm font-semibold">購入エビデンス</p>
                  {task.isEvidence ? (
                    <div>
                      <p className="text-xs">あり</p>
                      <p className="text-xs">{task.evidenceNotice}</p>
                    </div>
                  ) : (
                    <div>
                      <p className="text-xs">なし</p>
                    </div>
                  )}
                </div>
              </>
            )}
            <div className="mb-2 gap-2">
              <p className="text-sm font-semibold">買ってもらう商品の説明</p>
              <p className="text-xs">{task.description}</p>
            </div>
            <div className="mb-2 gap-2">
              <p className="text-sm font-semibold">買ってもらう商品の金額</p>
              <p className="text-xs">{addCommaAmount(task.price as number)}</p>
              <div>
                <p className="text-xs text-gray-500">※商品購入費用は、案件報酬額とは別で支払われます。</p>
                <p className="text-xs text-gray-500">
                  ※案件完了時に、案件報酬額とともに、Influfect内の出金可能額に計上されます。
                </p>
              </div>
            </div>
          </div>
        )}
        <button
          onClick={() => setToggle((value: boolean) => !value)}
          className="mx-auto my-0 mb-2 flex w-[190px] text-blue-500 underline focus:outline-none"
        >
          <span className="inline-block items-center text-xs">{isToggle ? '最小に戻す' : 'もっと見る'}</span>
          <DownArrowIcon
            height={16}
            width={16}
            fill="#3b82f6"
            className={`text-blue-500 transition-transform duration-300 ${isToggle ? 'rotate-180' : ''}`}
          />
        </button>
      </div>
    </div>
  );
};
